var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"living-options-properties"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"properties"},[_c('h3',[_vm._v("Properties")]),_c('button',{staticClass:"btn btn-sm btn-primary mb-4",on:{"click":_vm.addProperty}},[_vm._v("\n          Add Property\n        ")]),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"status-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterActiveStates),expression:"filterActiveStates"}],attrs:{"type":"checkbox","id":"active","value":"Active"},domProps:{"checked":Array.isArray(_vm.filterActiveStates)?_vm._i(_vm.filterActiveStates,"Active")>-1:(_vm.filterActiveStates)},on:{"change":function($event){var $$a=_vm.filterActiveStates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Active",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterActiveStates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterActiveStates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterActiveStates=$$c}}}}),_c('label',{staticClass:"status-option__label",attrs:{"for":"active"}},[_vm._v("Active")])]),_c('div',{staticClass:"status-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterActiveStates),expression:"filterActiveStates"}],attrs:{"type":"checkbox","id":"inactive","value":"Inactive"},domProps:{"checked":Array.isArray(_vm.filterActiveStates)?_vm._i(_vm.filterActiveStates,"Inactive")>-1:(_vm.filterActiveStates)},on:{"change":function($event){var $$a=_vm.filterActiveStates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Inactive",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterActiveStates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterActiveStates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterActiveStates=$$c}}}}),_c('label',{staticClass:"status-option__label",attrs:{"for":"inactive"}},[_vm._v("Inactive")])])])]),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Filter By Status")]),_vm._l((_vm.filterStatusOptions),function(status){return _c('div',{key:status,staticClass:"row col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterStatuses),expression:"filterStatuses"}],attrs:{"type":"checkbox","id":status},domProps:{"value":status,"checked":Array.isArray(_vm.filterStatuses)?_vm._i(_vm.filterStatuses,status)>-1:(_vm.filterStatuses)},on:{"change":function($event){var $$a=_vm.filterStatuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=status,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterStatuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterStatuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterStatuses=$$c}}}}),_c('label',{staticClass:"status-option__label",attrs:{"for":status}},[_vm._v("\n                "+_vm._s(status)+"\n              ")])])})],2)]),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-4"},[_c('label',{attrs:{"for":"filterRelease"}},[_vm._v("Filter By Release")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterReleaseId),expression:"filterReleaseId"}],staticClass:"form-control",attrs:{"name":"filterRelease"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterReleaseId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All Releases")]),_vm._l((_vm.subsectionsOrdered),function(subsection){return _c('option',{domProps:{"value":subsection.id}},[_vm._v("\n                "+_vm._s(subsection.label)+"\n              ")])})],2)])]),_c('div',{staticClass:"mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propertiesFilterText),expression:"propertiesFilterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filter properties"},domProps:{"value":(_vm.propertiesFilterText)},on:{"input":function($event){if($event.target.composing)return;_vm.propertiesFilterText=$event.target.value}}})]),_c('v-table',{attrs:{"columns":[
            {
              label: 'Label',
              field: 'label',
            },
            {
              label: 'Status',
              field: 'status',
              options: {
                sortable: true,
                callback: function (row) {
                  _vm.filterByStatus(row);
                },
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-';
                  } else {
                    switch (fieldValue) {
                      case 'Available':
                        return `<div class='status status--available table-link'>${fieldValue}</div>`;

                      case 'Coming Soon':
                        return `<div class='status status--coming-soon table-link'>${fieldValue}</div>`;

                      case 'On Hold':
                        return `<div class='status status--on-hold table-link'>${fieldValue}</div>`;

                      case 'Sold':
                        return `<div class='status status--sold table-link'>${fieldValue}</div>`;

                      case 'Builder Lots':
                        return `<div class='status status--builder-lots table-link'>${fieldValue}</div>`;

                      case 'Not Released':
                        return `<div class='status status--not-released table-link'>${fieldValue}</div>`;

                      default:
                        return `<div class='table-link'>${fieldValue}</div>`;
                    }
                  }
                },
              },
            },
            {
              label: 'Price',
              field: 'price',
              options: {
                sortable: true,
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found' || !fieldValue) {
                    return '-';
                  } else {
                    return fieldValue.toLocaleString('en-AU', {
                      style: 'currency',
                      currency: 'AUD',
                      maximumSignificantDigits: 10,
                    });
                  }
                },
              },
            },

            {
              label: 'Subsection',
              field: 'subsection',
              options: {
                sortable: true,
                return: function (row) {
                  if (!row) {
                    return '-';
                  } else {
                    if (row.active) {
                      return `<a class='table-link' href='/live/subsections/${
                        row._id
                      }' target='_blank'>${_vm.stripTags(row.label)}</a>`;
                    } else {
                      return `<a title='Inactive' class='table-link table-link--inactive' href='/live/subsections/${
                        row._id
                      }' target='_blank'>${_vm.stripTags(row.label)}</a>`;
                    }
                  }
                },
              },
            },
            {
              label: 'Living Option',
              field: 'livingOption',
              options: {
                sortable: true,
                return: function (row) {
                  if (!row) {
                    return '-';
                  } else {
                    if (row.active) {
                      return `<a class='table-link' href='/live/masterplan/${
                        row._id
                      }' target='_blank'>${_vm.stripTags(row.label)}</a>`;
                    } else {
                      return `<a title='Inactive' class='table-link table-link--inactive' href='/live/masterplan/${
                        row._id
                      }' target='_blank'>${_vm.stripTags(row.label)}</a>`;
                    }
                  }
                },
              },
            },
            {
              label: 'Dwelling',
              field: 'dwelling',
              options: {
                sortable: true,
                return: function (row) {
                  if (!row) {
                    return '-';
                  }
                  if (row.active) {
                    return `<a class='table-link' href='/live/dwellings/${row._id}' target='_blank'>${row.label}</a>`;
                  } else {
                    return `<a title='Inactive' class='table-link table-link--inactive' href='/live/dwellings/${row._id}' target='_blank'>${row.label}</div>`;
                  }
                },
              },
            },
          ],"rows":_vm.filteredProperties,"show-active-toggle":_vm.activeUser.access.includes('live-toggle'),"save-action":"SAVE_PROPERTY"},on:{"edit":function($event){return _vm.editProperty($event._id)},"clone":function($event){return _vm.cloneProperty($event)},"delete":function($event){return _vm.deleteProperty($event._id)}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }